import { userModule } from '@user/module';
import { userManagerModule } from '@userManager/module';
import { eventManagerModule } from '@eventManager/module';
import { pointOfSaleModule } from '@pointOfSale/module';
import { productMasterModule } from '@productMaster/module';
import { socialMediaModule } from '@socialMedia/module';
import { profileModule } from './views/profile/module';
import { getters } from './getters';
import * as actions from './actions';
import { mutations } from './mutations';
import { state } from './models';

export const dynameatModule = {
  state,
  actions,
  mutations,
  getters,
  modules: {
    pointOfSale: pointOfSaleModule,
    profile: profileModule,
    user: userModule,
    userManager: userManagerModule,
    productMaster: productMasterModule,
    eventManager: eventManagerModule,
    socialMedia: socialMediaModule
  },
};
